import {
  EntityTypeInvestmentJurisdictionWithNestedObjectResponse,
  EntityTypeResponseWithNestedObjects,
} from '../../../../web-api-client';
import { EntityType } from '../../models';
import { mapCountryFromResponse } from '../country/map-country-from-response';
import { mapEntityTypeInvJurisdictionFromResponse } from './map-entity-type-investment-jurisdiction-from-response';

export const mapEntityTypeFromResponse = (
  response: EntityTypeResponseWithNestedObjects
): EntityType => ({
  entityTypeId: response.entityTypeId!,
  name: response.name!,
  country: response.country
    ? mapCountryFromResponse(response.country)
    : undefined,
  isDefault: response.isDefault ?? false,
  isActive: response.isActive ?? false,
  created: response.created!,
  description: response.description!,
  entityTypeInvestmentJurisdiction:
    response.entityTypeInvestmentJurisdictionEntityTypes
      ? response.entityTypeInvestmentJurisdictionEntityTypes.map(
          (
            entityTypeInvJurisdiction: EntityTypeInvestmentJurisdictionWithNestedObjectResponse
          ) =>
            mapEntityTypeInvJurisdictionFromResponse(entityTypeInvJurisdiction)
        )
      : [],
});
